/**
 * Shared utility for consistent client color assignment.
 * Used across Clientes, ClienteForm, Citas, and Dashboard components.
 */

const COLORES = [
  '#007bff', '#28a745', '#dc3545', '#ffc107', '#17a2b8',
  '#6f42c1', '#fd7e14', '#20c997', '#e83e8c', '#6610f2',
  '#0dcaf0', '#198754', '#ff006e', '#8338ec', '#3a86ff',
  '#06ffa5', '#ffbe0b', '#fb5607', '#ff006e', '#8338ec',
  '#ff1744', '#00e676', '#00bcd4', '#ff9800', '#9c27b0',
  '#3f51b5', '#f44336', '#4caf50', '#2196f3', '#ff5722',
  '#009688', '#795548', '#607d8b', '#e91e63', '#9e9e9e',
  '#673ab7', '#ffeb3b', '#cddc39', '#00bcd4', '#ff4081',
  '#4caf50', '#ff9800', '#2196f3', '#f44336', '#9c27b0',
  '#00bcd4', '#ff5722', '#009688', '#795548', '#607d8b',
  '#e91e63', '#9e9e9e', '#673ab7', '#ffeb3b', '#cddc39',
  '#8bc34a', '#ffc107', '#ff9800', '#f44336', '#e91e63',
  '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4',
  '#00bcd4', '#009688', '#4caf50', '#8bc34a', '#cddc39',
  '#ffeb3b', '#ffc107', '#ff9800', '#ff5722', '#795548',
  '#9e9e9e', '#607d8b', '#455a64', '#37474f', '#263238',
  '#ff6f00', '#e65100', '#ff3d00', '#d50000', '#c51162',
  '#aa00ff', '#6200ea', '#304ffe', '#2962ff', '#0091ea',
  '#00b8d4', '#00bcd4', '#00acc1', '#0097a7', '#00838f',
  '#006064', '#004d40', '#1b5e20', '#33691e', '#558b2f',
  '#827717', '#f57f17', '#f9a825', '#fbc02d', '#fdd835',
];

export const getClienteColor = (clienteId, colorPersonalizado = null) => {
  if (colorPersonalizado) return colorPersonalizado;
  if (!clienteId) return '#6c757d';
  return COLORES[clienteId % COLORES.length];
};
